import CampaignRelativeIcon from 'public/assets/img/campaign-relative.svg'
import CampaignFixedIcon from 'public/assets/img/campaign-fixed.svg'
import CampaignImmediateIcon from 'public/assets/img/campaign-immediate.svg'
import React, { FC } from 'react'
import { t } from '@lingui/macro'
import { SingleCampaign } from './ManageCampaignPage'
import Tooltip from '../../components/common/tooltip/Tooltip'
import { CampaignScheduleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { CampaignDetailQuery } from './ManageCampaignPage.codegen'

export function countOfActionsInCampaign(
  campaign: NonNullable<NonNullable<CampaignDetailQuery['admin']>['campaign']>
): number {
  return (
    campaign.emailActions.length +
    campaign.banners.length +
    campaign.topicShareActions.length +
    campaign.pathwayShareActions.length +
    campaign.certificationShareActions.length +
    campaign.surveyShareActions.length +
    campaign.messageActions.length
  )
}

interface IProps {
  scheduleType: CampaignScheduleEnum
  withTooltip?: boolean
}

export const isCampaignRelative = (campaign: SingleCampaign) => {
  return campaign.schedule_type === CampaignScheduleEnum.RELATIVE
}

export const isCampaignFixed = (campaign: SingleCampaign) => {
  return campaign.schedule_type === CampaignScheduleEnum.FIXED
}

export const isCampaignImmediate = (campaign: SingleCampaign) => {
  return campaign.schedule_type === CampaignScheduleEnum.IMMEDIATE
}

export const IconByCampaignType: FC<IProps> = ({
  scheduleType,
  withTooltip,
  ...props
}) => {
  if (scheduleType === CampaignScheduleEnum.IMMEDIATE) {
    if (withTooltip)
      return (
        <Tooltip text={t`Immediate campaign`}>
          <ImmediateCampaignIcon {...props} />
        </Tooltip>
      )
    else return <ImmediateCampaignIcon {...props} />
  }
  if (scheduleType === CampaignScheduleEnum.FIXED) {
    if (withTooltip)
      return (
        <Tooltip text={t`Fixed campaign`}>
          <FixedCampaignIcon {...props} />
        </Tooltip>
      )
    else return <FixedCampaignIcon {...props} />
  }
  if (scheduleType === CampaignScheduleEnum.RELATIVE) {
    if (withTooltip)
      return (
        <Tooltip text={t`Relative campaign`}>
          <RelativeCampaignIcon {...props} />
        </Tooltip>
      )
    else return <RelativeCampaignIcon {...props} />
  }
  return null
}

export const RelativeCampaignIcon: FC = (props) => {
  return (
    <img src={CampaignRelativeIcon} alt={t`Relative campaign`} {...props} />
  )
}

export const FixedCampaignIcon: FC = (props) => {
  return <img src={CampaignFixedIcon} alt={t`Fixed campaign`} {...props} />
}

export const ImmediateCampaignIcon: FC = (props) => {
  return (
    <img src={CampaignImmediateIcon} alt={t`Immediate campaign`} {...props} />
  )
}
